// Importing Protractor images
import Protractor1 from '@/assets/images/protractor/Protractor-01.png'
import Protractor2 from '@/assets/images/protractor/Protractor-02.png'
import Protractor3 from '@/assets/images/protractor/Protractor-03.png'
import Protractor4 from '@/assets/images/protractor/Protractor-04.png'
import Protractor5 from '@/assets/images/protractor/Protractor-05.png'
import Protractor6 from '@/assets/images/protractor/Protractor-06.png'

export const protractor_templates = [{
	id : 1,
	title : 'Protractor 1',
	img : Protractor1
},{
	id : 2,
	title : 'Protractor 2',
	img : Protractor2
},{
	id : 3,
	title : 'Protractor 3',
	img : Protractor3
},{
	id : 4,
	title : 'Protractor 4',
	img : Protractor4
},{
	id : 5,
	title : 'Protractor 5',
	img : Protractor5
},{
	id : 6,
	title : 'Protractor 6',
	img : Protractor6
}]

export const defaultProtractorValue = () => {
	return {
		template : null,
		angle : 0,
		angle_direction: "C",
		answer_angle: 0,
		is_user_selectable : false,
		arrow_styles:{
            width: 3,
			height: 75,
			bg_color: "#000"
        },
		styles:{
			width : 150,
				height : 150,
				font_color : '#000'
		}
		
	}
}